var defaultKonamiCode = [
    'ArrowUp',
    'ArrowUp',
    'ArrowDown',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'ArrowLeft',
    'ArrowRight',
    'KeyB',
    'KeyQ'
];
var konami = function (handler, code) {
    if (code === void 0) { code = defaultKonamiCode; }
    var codeLeft = code;
    var resetKonamiCode = function () {
        codeLeft = code;
    };
    var keyDownHandler = function (e) {
        if (e.code.toString() === codeLeft[0]) {
            codeLeft.shift();
            if (codeLeft.length === 0) {
                resetKonamiCode();
                handler();
            }
        }
        else {
            resetKonamiCode();
        }
    };
    document.addEventListener('keydown', keyDownHandler);
    return keyDownHandler;
};
export default konami;
//# sourceMappingURL=index.js.map